import TabSelector from '@/global/TabSelector/TabSelector';

function HeatmapLineDashboard(props) {
  const { chartVariables, chartInfo, setChartInfo } = props;

  function changeChartInfoHandler(newVariableValue) {
    const selectedVariable = chartVariables.find(v => v.ident === newVariableValue);
    if (!selectedVariable) return;

    setChartInfo(prevChartInfo => ({
      ...prevChartInfo,
      variable: selectedVariable.ident,
      variableName: selectedVariable.name,
      variableFullName: selectedVariable.fullName,
    }));
  }

  return (
    <div className="graph-dashboard">
      <p>Select by:</p>
      <TabSelector
        options={chartVariables.map(v => ({
          label: v.name,
          value: v.ident,
        }))}
        value={chartInfo.variable}
        onChange={changeChartInfoHandler}
        variant="primary"
        size="md"
      />
    </div>
  );
}

export default HeatmapLineDashboard;
